export const MAX_PHOTOS = 35
export const SECTION_COMPONENT_NAME = 'tiktok_carousel_section'

// An empty slot already counts toward the cap, so one more than the free
// slots may be picked at once.
export const getPickerArgs = (index: number, modulesLength: number) => ({
  destination: 'carousel',
  index,
  allowMultiple: Math.max(MAX_PHOTOS + 1 - modulesLength, 1),
  uploadType: 'image' as const,
})
